<app-breadcrumb></app-breadcrumb>

<div *ngIf="cargando">
  <mat-spinner></mat-spinner>
</div>
<div *ngIf="!cargando">
  <div class="row">
    <div class="col-md-8">
      <ngb-carousel
        class="product-image-carousel"
        *ngIf="Imagenes"
        [showNavigationArrows]="false"
        [showNavigationIndicators]="true"
      >
        <ng-template ngbSlide *ngFor="let img of Imagenes; let i = index">
          <div class="picsum-img-wrapper">
            <img
              [src]="img.src"
              [alt]="productImageAlt(img)"
              [attr.loading]="i === 0 ? 'eager' : 'lazy'"
              [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
              decoding="async"
            />
          </div>
          <div class="carousel-caption"></div>
        </ng-template>
      </ngb-carousel>
    </div>

    <div class="col-md-4">
      <div class="product-dtl mt-3" *ngFor="let dp of Dp">
        <div class="product-info">
          <div class="product-mark">
            {{ dp.Marca }}
          </div>
          <h1 class="product-name">
            {{ dp.Nombre }}
          </h1>
          <a
            class="reviews-counter"
            href="#review"
            data-toggle="tab"
            aria-label="Ver opiniones del producto"
          >
            <ngb-rating
              [readonly]="true"
              [max]="5"
              [rate]="promedioOpiniones"
            ></ngb-rating>
            <span *ngIf="Comentarios.length; else sinOpiniones">
              {{ promedioOpiniones | number: "1.1-1" }} ({{
                Comentarios.length
              }}
              {{ Comentarios.length === 1 ? "opinion" : "opiniones" }})
            </span>
            <ng-template #sinOpiniones><span>Sin opiniones</span></ng-template>
          </a>

          <div class="product-price-discount">
            {{ ModelSelected?.Precio | money }}
          </div>
        </div>

        <p>{{ Dp[0].DescripcionC }}</p>

        <!-- condicional de variante -->

        <div *ngIf="Dp[0].Modelos.length > 1" class="col-12 p-0 pt-3 mr-2 mb-3">
          <div class="row">
            <label class="mr-2 mb-0 align-self-center" for="ModelSelected">
              Modelo
            </label>
            <select
              name="Modelos"
              [(ngModel)]="ModelSelected"
              id="ModelSelected"
              (change)="ModeloSeleccionado()"
              class="form-control col"
            >
              @for (item of Dp[0].Modelos; track item) {
                <option [ngValue]="item" selected>{{ item.Modelo }}</option>
              }
            </select>
          </div>
        </div>

        <!-- Selector de cantidad -->
        <div class="row">
          <label class="mr-2 mb-0 align-self-center">Cantidad: </label>
          <div class="dropdown col p-0">
            <ng-container *ngIf="stockDisponible > 0; else noStock">
              <button
                class="btn btn-block border-secondary dropdown-toggle text-left d-flex align-items-center"
                type="button"
                (click)="mostrarDropdown = !mostrarDropdown"
                [disabled]="stockDisponible === 0"
              >
                {{ cantidadSeleccionada }} unidad{{
                  cantidadSeleccionada > 1 ? "es" : ""
                }}
                <span class="quantity-stock align-items-end mr-3 ml-auto text-muted small"
                  >({{ stockDisplay }} disponibles)</span
                >
              </button>
              <div
                class="dropdown-menu w-100 shadow-sm p-0"
                [class.show]="mostrarDropdown"
                style="min-width: 250px"
              >
                <button
                  class="dropdown-item px-3 py-2 border-bottom"
                  *ngFor="let op of opcionesCantidad"
                  (click)="seleccionarCantidad(op.value)"
                >
                  {{ op.label }}
                </button>
                <div class="input-group input-group-sm p-3 pt-2">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Ingresar cantidad"
                    [value]="cantidadPersonalizada"
                    (input)="onInputCantidadPersonalizada($event)"
                  />
                  <div class="input-group-append">
                    <!-- disabled]="!isCantidadPersonalizadaValida()" -->
                    <button
                      class="btn btn-primary"
                      [disabled]="!isCantidadPersonalizadaValida()"
                      (click)="aplicarCantidadPersonalizada()"
                    >
                      Aplicar
                    </button>
                  </div>
                </div>
                <div
                  *ngIf="
                    cantidadPersonalizada && !isCantidadPersonalizadaValida()
                  "
                  class="text-danger px-3 pb-2"
                  style="font-size: 0.85em"
                >
                  No hay suficientes unidades disponibles.
                </div>
              </div>
            </ng-container>
            <ng-template #noStock>
              <span
                class="btn-block border border-danger rounded text-danger text-center py-1"
              >
                No disponible
              </span>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- agregar al carrito y boton de comprar y compartir -->
      <div class="row">
        <div class="col p-0">
          <button
            data-tip="Agregar al Carrito"
            class="round-black-btn btn-block"
            (click)="AgregaProducto()"
            [disabled]="stockDisponible === 0"
          >
            <i class="bx bx-cart-add bx-sm mr-2"></i>
            Agregar Carrito
          </button>
        </div>
      </div>
      <div class="btns-prdocuto mt-3">
        <!-- copiar enlace -->
        <div class="btn-producto-5">
          <button
            data-tip="Copiar el link del producto"
            class="btn btn-block btn-outline-secondary"
            (click)="Compartir()"
          >
            <i class="bx bx-link-alt"></i>
            <br />
            <small>Copiar link</small>
          </button>
        </div>
        <!-- agregar favoritos -->
        <div class="btn-producto-5">
          <button
            data-tip="Obtener el link del producto"
            class="btn btn-block btn-outline-secondary"
            (click)="addWish('0')"
          >
            <i class="bx bx-heart"></i>
            <br />
            <small>Favoritos</small>
          </button>
        </div>
        <!-- comprar ahora con paypal -->
        @if (IdUsuario != "0") {
          <div class="btn-producto-12">
            <button
              data-tip="Obtener el link del producto"
              class="btn btn-block btn-outline-secondary flex-grow-1"
              (click)="ComprarAhora()"
            >
              <i class="bx bxl-paypal"></i>
              <br />
              <small>Comprar Ahora</small>
            </button>
          </div>
        }
      </div>

      <div class="social-media-boxes">
        <div class="product-share" aria-label="Compartir producto">
          <span class="product-share__label">Compartir en redes</span>
          <div class="product-share__buttons">
            <button
              type="button"
              class="product-share__button"
              aria-label="Compartir por WhatsApp"
              (click)="shareProduct('whatsapp')"
            >
              <i class="bx bxl-whatsapp"></i>
            </button>
            <button
              type="button"
              class="product-share__button"
              aria-label="Compartir en Facebook"
              (click)="shareProduct('facebook')"
            >
              <i class="bx bxl-facebook-circle"></i>
            </button>
            <button
              type="button"
              class="product-share__button"
              aria-label="Compartir en X"
              (click)="shareProduct('x')"
            >
              <i class="bx bx-x"></i>
            </button>
          </div>
        </div>

        <div
          class="product-social-proof"
          aria-label="Perfiles oficiales de Clave Winds"
        >
          <span>Siguenos para novedades y soporte</span>
          <div>
            <a
              *ngFor="let profile of socialProfiles"
              [href]="profile.url"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="profile.label"
            >
              <i [class]="profile.icon"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="product-dtl product-sku">
        <p>
          <small class="text-muted" style="font-size: smaller">
            SKU : <em>{{ ModelSelected?.SKU }}</em>
          </small>
        </p>
      </div>
    </div>
  </div>

  <!-- info tabs -->
  <div class="product-info-tabs">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="description-tab"
          data-toggle="tab"
          href="#description"
          role="tab"
          aria-controls="description"
          aria-selected="true"
        >
          Descripción
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="review-tab"
          data-toggle="tab"
          href="#review"
          role="tab"
          aria-controls="review"
          aria-selected="false"
        >
          Opiniones
        </a>
      </li>
    </ul>

    <div class="tab-content" id="myTabContent">
      <div
        *ngIf="Dp.length > 0"
        class="tab-pane fade show active"
        id="description"
        role="tabpanel"
        aria-labelledby="description-tab"
      >
        <h2>Descripcion de {{ Dp[0].Nombre }}</h2>
        <p [innerHTML]="Dp[0].DescripcionL | nl2br"></p>
      </div>

      <div
        class="tab-pane fade"
        id="review"
        role="tabpanel"
        aria-labelledby="review-tab"
      >
        <div class="reviews-heading">
          <div>
            <h2>Opiniones de compradores</h2>
            <div class="reviews-summary" *ngIf="Comentarios.length">
              <strong>{{ promedioOpiniones | number: "1.1-1" }}</strong>
              <ngb-rating
                [readonly]="true"
                [max]="5"
                [rate]="promedioOpiniones"
              ></ngb-rating>
              <span
                >Basado en {{ Comentarios.length }}
                {{ Comentarios.length === 1 ? "opinion" : "opiniones" }}</span
              >
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            (click)="abrirOpinion(MdlOpinion)"
          >
            Escribir una opinion
          </button>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div *ngIf="Comentarios.length == 0">
              Esta variante aun no cuenta con opiniones de compradores
            </div>
            <div *ngFor="let c of Comentarios" class="review-item">
              <!-- Cards with media area -->
              <mat-card class="comentario-card">
                <mat-card-header>
                  <mat-card-title-group>
                    <mat-card-subtitle>{{ c.Nombre }}</mat-card-subtitle>
                    <mat-card-subtitle>
                      <ngb-rating
                        class="review-stars"
                        [readonly]="true"
                        [max]="5"
                        [(rate)]="c.Estrellas"
                      >
                      </ngb-rating>
                    </mat-card-subtitle>
                  </mat-card-title-group>
                </mat-card-header>
                <mat-card-content>
                  {{ c.Opinion }}
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #MdlOpinion let-modal>
    <div class="modal-header">
      <h2 class="modal-title h5 mb-0">Escribe tu opinion</h2>
      <button
        type="button"
        class="btn btn-close"
        aria-label="Cerrar"
        (click)="modal.dismiss()"
      >
        x
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formOpinion" (ngSubmit)="guardarOpinion()">
        <p class="mb-2">
          <strong>{{ Dp[0]?.Nombre }} {{ ModelSelected?.Modelo }}</strong>
        </p>
        <label class="d-block font-weight-bold" for="review-rating"
          >Calificacion</label
        >
        <ngb-rating
          id="review-rating"
          class="review-form-stars"
          [max]="5"
          formControlName="Estrellas"
        ></ngb-rating>
        <div
          class="text-danger small"
          *ngIf="
            formOpinion.get('Estrellas')?.touched &&
            formOpinion.get('Estrellas')?.invalid
          "
        >
          Selecciona de 1 a 5 estrellas.
        </div>

        <label class="d-block font-weight-bold mt-3" for="review-opinion"
          >Comentario</label
        >
        <textarea
          id="review-opinion"
          class="form-control"
          rows="5"
          maxlength="500"
          formControlName="Opinion"
          placeholder="Cuentanos tu experiencia con este producto"
        ></textarea>
        <div class="d-flex justify-content-between small mt-1">
          <span
            class="text-danger"
            *ngIf="
              formOpinion.get('Opinion')?.touched &&
              formOpinion.get('Opinion')?.invalid
            "
          >
            Escribe al menos 10 caracteres.
          </span>
          <span class="text-muted ml-auto"
            >{{ formOpinion.get("Opinion")?.value?.length || 0 }}/500</span
          >
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn btn-outline-secondary mr-2"
            (click)="modal.dismiss()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="formOpinion.invalid || guardandoOpinion"
          >
            {{ guardandoOpinion ? "Guardando..." : "Publicar opinion" }}
          </button>
        </div>
      </form>
    </div>
  </ng-template>

  <div class="row Recomendaciones" *ngIf="lsProdRec.length > 0">
    <div class="col-12 TitleSec">
      <h2>Recomendaciones</h2>
    </div>
    <div class="col-md-3 col-sm-6" *ngFor="let lt of lsProdRec; let i = index">
      <div class="ProductGrid">
        <div class="ProductImage">
          <a
            [routerLink]="productPath(lt)"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            (click)="detalleProducto(lt)"
          >
            <img
              class="pic-1"
              src="{{ lt.Modelos[0].Imagenes[0].src }}"
              [alt]="lt.Nombre"
              loading="lazy"
              decoding="async"
            />
          </a>
        </div>
        <div class="ProductContent">
          <div class="Mark">{{ lt.Marca }}</div>
          <a>
            <h3 class="Title truncate-text">{{ lt.Nombre }}</h3>
          </a>
          <div class="Price">{{ lt.Modelos[0].Precio | money }}</div>
        </div>
        <ul class="Social">
          <li>
            <a
              [routerLink]="productPath(lt)"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
              (click)="detalleProducto(lt)"
              data-tip="Ver"
            >
              <i class="fa fa-search"></i>
            </a>
          </li>
          <li>
            <a (click)="addWish(lt.IdProd)" data-tip="Agregar a Favoritos">
              <i class="fa fa-heart" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template #Mdlpaypal let-modal>
    <div class="modal-header">
      Comprar Ahora<button
        type="button"
        class="btn btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        x
      </button>
    </div>
    <div class="modal-body">
      <div #paypal></div>
    </div>
  </ng-template>
</div>
